import { useWeb3Context } from "@/contexts/web3";

import { useMarginlyApi } from "./api";

export const useFarmRepresentation = (poolAddress?: `0x${string}`) => {
  const { internalChainId, getPoolByAddress } = useWeb3Context();

  const pool = getPoolByAddress(poolAddress);

  const uniswapAddress = pool?.pool.uniswapAddress;
  const isPendle = pool?.pool.isPendle;

  const { data: farmRepresentation } = useMarginlyApi({
    enabled: Boolean(internalChainId && uniswapAddress && isPendle),
    endpoint: "pendlePoolInfo",
    args: [internalChainId, uniswapAddress]!,
  });
  return {
    farmRepresentation,
  };
};
